import { Box } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import { selectTenantInfo } from '@sophocles/features/tenant/slice';

import CustomerGrid from './components/CustomerGrid';

function CustomerGridView(props) {
  const { loading } = props;
  const tenantInfo = useSelector(selectTenantInfo);

  const pageTitle = `${tenantInfo.customer_term} List`;

  return (
    <AppNav flex notFullHeight loading={loading} page="support_customers" {...props}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
          padding: '0 var(--page-px) var(--page-py)',
        }}
      >
        <TitleBar title={pageTitle} />
        <CustomerGrid />
      </Box>
    </AppNav>
  );
}

export default CustomerGridView;
